export const maintenancePieceAdditionalInformationDefaultColumns = [
  { value: 'field_name', label: '' },
  { value: 'field_value', label: '' },
]
